import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_SITE_SETTINGS, type SiteSettings } from "@/lib/site-settings";

export const SITE_SETTINGS_KEY = ["site-settings"];
export function useSiteSettings() {
  const query = useQuery({
    queryKey: SITE_SETTINGS_KEY,
    queryFn: async (): Promise<SiteSettings> => {
      const { data, error } = await supabase.from("site_settings").select("*").eq("id", true).maybeSingle();
      if (error) throw error;
      if (!data) return DEFAULT_SITE_SETTINGS;
      const { id: _id, updated_at: _updated, ...settings } = data;
      return settings;
    },
    staleTime: 60_000,
    retry: 1,
  });
  return { ...query, settings: query.data ?? DEFAULT_SITE_SETTINGS };
}